module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Grupo de Procedimento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grupoSelecionado),
      expression: "grupoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grupo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grupoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setGrupoSelecionado()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o grupo...")]), _vm._v(" "), _vm._l((_vm.grupos), function(grupo, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": grupo
      }
    }, [_vm._v(_vm._s(grupo.codigo) + " - " + _vm._s(grupo.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sub-Grupo")]), _vm._v(" "), _c('select-subgrupo', {
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "data_de"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "periodo"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.periodoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.periodo = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.periodo2 = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Agrupar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.agrupamento),
      expression: "filtros.agrupamento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agrupamento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "agrupamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Não agrupar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unidade"
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "procedimento"
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dia"
    }
  }, [_vm._v("Dia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Separar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.separacao),
      expression: "filtros.separacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "separacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "separacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "data"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dia"
    }
  }, [_vm._v("Dia da Semana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horario"
    }
  }, [_vm._v("Horários")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ignorar_prestador),
      expression: "filtros.ignorar_prestador"
    }],
    staticStyle: {
      "margin-top": "0.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.ignorar_prestador) ? _vm._i(_vm.filtros.ignorar_prestador, null) > -1 : (_vm.filtros.ignorar_prestador)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.ignorar_prestador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "ignorar_prestador", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "ignorar_prestador", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "ignorar_prestador", $$c)
        }
      }
    }
  }), _vm._v(" Ignorar prestador\n\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ignorar_profissional),
      expression: "filtros.ignorar_profissional"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.ignorar_profissional) ? _vm._i(_vm.filtros.ignorar_profissional, null) > -1 : (_vm.filtros.ignorar_profissional)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.ignorar_profissional,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "ignorar_profissional", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "ignorar_profissional", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "ignorar_profissional", $$c)
        }
      }
    }
  }), _vm._v(" Ignorar profissional\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.toogle),
      expression: "filtros.contadores.disponivel.toogle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.toogle) ? _vm._i(_vm.filtros.contadores.disponivel.toogle, null) > -1 : (_vm.filtros.contadores.disponivel.toogle)
    },
    on: {
      "click": function($event) {
        _vm.toogleAll('disponivel')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.toogle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "toogle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "toogle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "toogle", $$c)
        }
      }
    }
  }), _vm._v(" Disponível")]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.toogle),
      expression: "filtros.contadores.agendado.toogle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.toogle) ? _vm._i(_vm.filtros.contadores.agendado.toogle, null) > -1 : (_vm.filtros.contadores.agendado.toogle)
    },
    on: {
      "click": function($event) {
        _vm.toogleAll('agendado')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.toogle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "toogle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "toogle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "toogle", $$c)
        }
      }
    }
  }), _vm._v(" Agendado")]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.toogle),
      expression: "filtros.contadores.bloqueado.toogle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.toogle) ? _vm._i(_vm.filtros.contadores.bloqueado.toogle, null) > -1 : (_vm.filtros.contadores.bloqueado.toogle)
    },
    on: {
      "click": function($event) {
        _vm.toogleAll('bloqueado')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.toogle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "toogle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "toogle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "toogle", $$c)
        }
      }
    }
  }), _vm._v(" Bloqueado")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.primeira),
      expression: "filtros.contadores.toogle.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.primeira) ? _vm._i(_vm.filtros.contadores.toogle.primeira, null) > -1 : (_vm.filtros.contadores.toogle.primeira)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('primeira')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "primeira", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.primeira),
      expression: "filtros.contadores.disponivel.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.primeira) ? _vm._i(_vm.filtros.contadores.disponivel.primeira, null) > -1 : (_vm.filtros.contadores.disponivel.primeira)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "primeira", $$c)
        }
      }
    }
  }), _vm._v(" Primeira")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.primeira),
      expression: "filtros.contadores.agendado.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.primeira) ? _vm._i(_vm.filtros.contadores.agendado.primeira, null) > -1 : (_vm.filtros.contadores.agendado.primeira)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "primeira", $$c)
        }
      }
    }
  }), _vm._v(" Primeira")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.primeira),
      expression: "filtros.contadores.bloqueado.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.primeira) ? _vm._i(_vm.filtros.contadores.bloqueado.primeira, null) > -1 : (_vm.filtros.contadores.bloqueado.primeira)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "primeira", $$c)
        }
      }
    }
  }), _vm._v(" Primeira")])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.retorno),
      expression: "filtros.contadores.toogle.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.retorno) ? _vm._i(_vm.filtros.contadores.toogle.retorno, null) > -1 : (_vm.filtros.contadores.toogle.retorno)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('retorno')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "retorno", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.retorno),
      expression: "filtros.contadores.disponivel.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.retorno) ? _vm._i(_vm.filtros.contadores.disponivel.retorno, null) > -1 : (_vm.filtros.contadores.disponivel.retorno)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "retorno", $$c)
        }
      }
    }
  }), _vm._v(" Retorno")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.retorno),
      expression: "filtros.contadores.agendado.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.retorno) ? _vm._i(_vm.filtros.contadores.agendado.retorno, null) > -1 : (_vm.filtros.contadores.agendado.retorno)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "retorno", $$c)
        }
      }
    }
  }), _vm._v(" Retorno")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.retorno),
      expression: "filtros.contadores.bloqueado.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.retorno) ? _vm._i(_vm.filtros.contadores.bloqueado.retorno, null) > -1 : (_vm.filtros.contadores.bloqueado.retorno)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "retorno", $$c)
        }
      }
    }
  }), _vm._v(" Retorno")])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.local),
      expression: "filtros.contadores.toogle.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.local) ? _vm._i(_vm.filtros.contadores.toogle.local, null) > -1 : (_vm.filtros.contadores.toogle.local)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('local')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "local", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.local),
      expression: "filtros.contadores.disponivel.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.local) ? _vm._i(_vm.filtros.contadores.disponivel.local, null) > -1 : (_vm.filtros.contadores.disponivel.local)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "local", $$c)
        }
      }
    }
  }), _vm._v(" Local")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.local),
      expression: "filtros.contadores.agendado.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.local) ? _vm._i(_vm.filtros.contadores.agendado.local, null) > -1 : (_vm.filtros.contadores.agendado.local)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "local", $$c)
        }
      }
    }
  }), _vm._v(" Local")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.local),
      expression: "filtros.contadores.bloqueado.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.local) ? _vm._i(_vm.filtros.contadores.bloqueado.local, null) > -1 : (_vm.filtros.contadores.bloqueado.local)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "local", $$c)
        }
      }
    }
  }), _vm._v(" Local")])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.total),
      expression: "filtros.contadores.toogle.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.total) ? _vm._i(_vm.filtros.contadores.toogle.total, null) > -1 : (_vm.filtros.contadores.toogle.total)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('total')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "total", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.total),
      expression: "filtros.contadores.disponivel.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.total) ? _vm._i(_vm.filtros.contadores.disponivel.total, null) > -1 : (_vm.filtros.contadores.disponivel.total)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "total", $$c)
        }
      }
    }
  }), _vm._v(" Total")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.total),
      expression: "filtros.contadores.agendado.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.total) ? _vm._i(_vm.filtros.contadores.agendado.total, null) > -1 : (_vm.filtros.contadores.agendado.total)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "total", $$c)
        }
      }
    }
  }), _vm._v(" Total")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.total),
      expression: "filtros.contadores.bloqueado.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.total) ? _vm._i(_vm.filtros.contadores.bloqueado.total, null) > -1 : (_vm.filtros.contadores.bloqueado.total)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "total", $$c)
        }
      }
    }
  }), _vm._v(" Total")])])])])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_vm._v("Recarregar PDF "), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Oferta de Procedimentos",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf) ? _c('div', {
    staticClass: "row overflow",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, _vm._l((_vm.dataTable), function(itens, nome) {
    return _c('table', {
      key: nome,
      staticClass: "table table-bordered table-striped"
    }, [_c('thead', [_c('tr', [(_vm.filtros.agrupamento == 'dia') ? _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(" " + _vm._s(_vm._f("dataFormatada")(nome)))]) : _vm._e(), _vm._v(" "), (_vm.filtros.agrupamento == 'procedimento') ? _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Procedimento: " + _vm._s(nome))]) : _vm._e(), _vm._v(" "), (_vm.filtros.agrupamento == 'unidade' && !_vm.filtros.ignorar_prestador) ? _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Unidade: " + _vm._s(nome))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-striped table-hover"
    }, [_c('thead', [_c('tr', [(_vm.filtros.separacao == 'data') ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Dia")]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'dia') ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Dia da semana")]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'horario') ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Horário")]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_prestador) ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Unidade")]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_profissional) ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Profissional")]) : _vm._e(), _vm._v(" "), _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Agenda")]), _vm._v(" "), (_vm.isVisible('disponivel')) ? _c('th', {
      staticStyle: {
        "text-align": "center",
        "width": "10%"
      },
      attrs: {
        "colspan": _vm.getColSpan('disponivel')
      }
    }, [_vm._v("Disponível")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('agendado')) ? _c('th', {
      staticStyle: {
        "text-align": "center",
        "width": "10%"
      },
      attrs: {
        "colspan": _vm.getColSpan('agendado')
      }
    }, [_vm._v("Agendado")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('bloqueado') && !itens[0].paciente) ? _c('th', {
      staticStyle: {
        "text-align": "center",
        "width": "10%"
      },
      attrs: {
        "colspan": _vm.getColSpan('bloqueado')
      }
    }, [_vm._v("Bloqueado")]) : _vm._e()]), _vm._v(" "), (!itens[0].paciente) ? _c('tr', [(_vm.filtros.contadores.disponivel.primeira) ? _c('th', [_vm._v("P")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.retorno) ? _c('th', [_vm._v("R")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.local) ? _c('th', [_vm._v("L")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.total) ? _c('th', [_vm._v("T")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.primeira) ? _c('th', [_vm._v("P")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.retorno) ? _c('th', [_vm._v("R")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.local) ? _c('th', [_vm._v("L")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.total) ? _c('th', [_vm._v("T")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.primeira) ? _c('th', [_vm._v("P")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.retorno) ? _c('th', [_vm._v("R")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.local) ? _c('th', [_vm._v("L")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.total) ? _c('th', [_vm._v("T")]) : _vm._e()]) : _c('tr', [_c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Pacientes")]), _vm._v(" "), _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Pacientes")])])]), _vm._v(" "), (!itens[0].paciente) ? _c('tbody', _vm._l((itens), function(item, index) {
      return _c('tr', {
        key: index
      }, [(_vm.filtros.separacao == 'dia') ? _c('td', [_vm._v(_vm._s(_vm._f("dia")(parseInt(item.dia_semana))))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'data') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'horario') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " das " + _vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_prestador) ? _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_profissional) ? _c('td', [_vm._v(_vm._s(item.profissional ? item.profissional.nome : "Agenda sem profissional"))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.codigo : item.contrato_subgrupo.subgrupo.codigo) + " - " + _vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.nome : item.contrato_subgrupo.subgrupo.nome))]), _vm._v(" "), (_vm.filtros.contadores.disponivel.primeira) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_primeira))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.retorno) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_retorno ? item.quantidade_retorno : "0"))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.local) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_local))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.total) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('strong', [_vm._v(_vm._s(item.quantidade_total))])]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.primeira) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_primeira_agendada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.retorno) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_retorno_agendada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.local) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_local_agendada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.total) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('strong', [_vm._v(_vm._s(item.quantidade_total_agendada))])]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.primeira) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_primeira_bloqueada == null ? 0 : item.quantidade_primeira_bloqueada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.retorno) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_retorno_bloqueada == null ? 0 : item.quantidade_retorno_bloqueada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.local) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_local_bloqueada == null ? 0 : item.quantidade_local_bloqueada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.total) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('strong', [_vm._v(_vm._s(item.quantidade_total_bloqueada == null ? 0 : item.quantidade_total_bloqueada))])]) : _vm._e()])
    })) : _c('tbody', _vm._l((itens), function(item, index) {
      return _c('tr', {
        key: index
      }, [(_vm.filtros.separacao == 'dia') ? _c('td', [_vm._v(_vm._s(_vm._f("dia")(parseInt(item.dia_semana))))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'data') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'horario') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " das " + _vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_prestador) ? _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_profissional) ? _c('td', [_vm._v(_vm._s(item.profissional ? item.profissional.nome : "Agenda sem profissional"))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.codigo : item.contrato_subgrupo.subgrupo.codigo) + " - " + _vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.nome : item.contrato_subgrupo.subgrupo.nome))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(item.quantidade_paciente))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(item.quantidade_paciente_agendada))])])
    }))])])])])])
  }))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-10 col-sm-2 text-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pdf),
      expression: "!pdf"
    }],
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF")])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Oferta de Procedimentos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', [_c('strong', [_vm._v("Contadores a exibir")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4b428e74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/ofertas/index.vue
// module id = 840
// module chunks = 0